export const ROUTE_PATH = '/clean/cleaner/member' as const
